import { useEffect, useContext, useState, useRef } from "react";
import { useParams } from "react-router";
import { StoreContext } from "../../store/Store";
import { Loading, useRedirect } from "react-admin";

import Box from "@mui/material/Box";
// import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
// import Typography from "@mui/material/Typography";

import IEventSession from "../../dataProvider/interfaces/IEventSession";
import { DropdownButton, GenericList } from "../../components";
import { dataType } from "../../components/GenericList/GenericList";
import { BiChevronDown, BiSearch } from "react-icons/bi";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { RiGroupLine, RiUserLine } from "react-icons/ri";
import { BiTrash, BiX } from "react-icons/bi";
import { APIContext } from "../../store/APIStore";
import CSVUploadFlow from "./CSVUploadFlow/CSVUploadFlow";
import { useLocation } from "react-router-dom";
import { jobStatus } from "../../dataProvider/interfaces/IEvent";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import { theme } from "../../theme";
import FdButton from "../../components/UIComponents/Button/FdButton";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import { debounce } from "lodash"
import { BsPersonCheck } from "react-icons/bs";

const classes = {
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    contentWrapper: {
      height: "calc(100vh - 105px)",
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    topActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    listContent: {
      position: "relative",
      width: "100%",
      flexGrow: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      overflow: "auto",
    },
    topFilters: {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    searchForm: {
      padding: "0px 10px",
      display: "flex",
      flexGrow: 1,
      alignItems: "center",
      boxShadow: "0px 4px 8px rgb(0 0 0 / 5%)",
      border: "1px solid #E7E7E7",
      borderRadius: "6px",
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 0,
    },
    searchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
      border: 0,
      boxShadow: "none",
      marginTop:0,
      marginRight:0,
      marginBottom: 0,
      "&.MuiFormControl-root": {
        m: 0,
      },
      "& .MuiInputBase-root": {
        padding: "9px 10px 9px 10px",
        borderTopRightRadius: "0 !important",
        borderBottomRightRadius: "0 !important",
      },
    },
    searchButton: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: "5px",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: "5px",
    },
    clearIcon: {
      cursor: "pointer",
    marginRight:'10px',
    },
  };

const EventSessions = (props: any) => {
  const { eventId } = useParams() as any;
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const redirect = useRedirect();
  const {showFullSession} = props;
  const [eventSessions, setEventSessions] = useState<IEventSession[] | null>(
    null
  );
  const [scrollLoading,] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  const searchRef = useRef<any>(); // search bar
  const notificationRef = useRef<any>(); // notification bar
  const uploadDialogRef = useRef<any>(); // upload file dialog
  const location = useLocation().search;
  const [, setCharacters] = useState<string[]>([]);

  // permissions
  const canManageSession = useHasPermissions(PERMISSIONS.CAN_MANAGE_SESSION);

  const debouncedSearch = useRef(debounce(async (criteria) => {
    setCharacters(await fetchEventSessions(criteria));
  }, 1000)).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state.selectedEvent) {
      // check for search key and fetch sessions
      const search = new URLSearchParams(location).get("search");
      if (search) {
        setSearchKey(search);
        fetchEventSessions(search);
      } else {
        fetchEventSessions();
      }
    }

    return () => {
      setEventSessions(null);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedEvent]);

  const fetchData = () => {
    // fetch selected event
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }

    // fetch session locations for the selected event
    fetchSessionLocations();
  };

  const fetchSessionLocations = async () => {
    try {
      const locations = (await api.locationService.getLocations(
        eventId
      )) as any;
      dispatch({ type: "SET_SESSION_LOCATIONS", payload: locations });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const fetchEventSessions = async (keyword = "") => {
    setEventSessions(null);
    try {
      let sessions = [];
      if (keyword.length > 0) {
        // const filteredSessions = sessions.filter(
        //   (session: IEventSession) =>
        //     (session.name && session.name.indexOf(keyword) >= 0) ||
        //     (session.description && session.description.indexOf(keyword) >= 0)
        // );
        sessions = (await api.sessionService.searchSession(
          eventId,
          keyword
        )) as any;
      } else {
        sessions = (await api.sessionService.getSessions(eventId)) as any;
      }
      setEventSessions(sessions);
      return sessions;
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };



  const onSearchClick = (e: any) => {
    // fetch sessions

    redirect(
      `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.SESSIONS}?search=${searchKey}`
    );
    fetchEventSessions(searchKey);
  };

  const handleBulkDelete = async (items: number[]) => {
    try {
      setEventSessions(null);
      await Promise.all(
        items.map((item) => {
          return api.sessionService.delete(item);
        })
      );
      fetchEventSessions();
      notificationRef.current?.show(
        "Sessions successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDeleteAll = async () => {
    try {
      await api.sessionService.deleteAll(state.selectedEvent.id);
      fetchEventSessions();
      notificationRef.current?.show(
        "Deleted all sessions",
        notificationType.Success
      );
    } catch (error: any) {
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleDeleteSession = async (id: number) => {
    try {
      await api.sessionService.delete(id);
      fetchEventSessions();
      notificationRef.current?.show(
        "Session successfully deleted",
        notificationType.Success
      );
    } catch (error: any) {
      console.log(error.response);
      notificationRef.current?.show(
        error.response.data.message,
        notificationType.Error
      );
    }
  };

  const handleBulkSessions = (items: number[]) => {
    console.log("items", items);
  }

  const bulkActions = [
    {
      label: "Delete",
      key: "delete",
      callback: handleBulkDelete,
      startIcon: <BiTrash />,
    },
    {
      label: "Session",
      key: "session",
      callback: handleBulkSessions,
      startIcon: <BsPersonCheck fontSize="medium" />,
    },
  ];

  // actions shown on top right
  const customActions = [
    {
      label: "Delete all",
      key: "delete-all",
      callback: handleDeleteAll,
      startIcon: <BiTrash />,
    },
  ];


  const handleSearchKeyDown =  (e: any) => {

    if (e.keyCode === 13) {
      redirect(
        `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.SESSIONS}?search=${searchKey}`
      );

      // fetch sessions
      fetchEventSessions(searchKey);
    }
  };

  const handleSearchClear = () => {
    redirect(
      `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.SESSIONS}`
    );

    setSearchKey("");

    // fetch sessions
    fetchEventSessions();
  };

  if (!eventId || eventId === "undefined") {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingTop="50px"
      >
        Please, select an event!
      </Box>
    );
  }

  

 

  return (
    <>
      <Box sx={classes.wrapper}>
        <Box sx={classes.contentWrapper}>
          {showFullSession && <Box sx={classes.topActions}>
            <FdTypography label="Sessions" component="h3" variant="h3" />

            {canManageSession && (
              <DropdownButton
                label="Add sessions"
                endIcon={<BiChevronDown />}
                options={[
                  {
                    key: "single-session",
                    label: "Single session",
                    callback: () => {
                      redirect(
                        `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.NEW_SESSION}`
                      );
                    },
                    startIcon: <RiUserLine fontSize="medium" />,
                  },
                  {
                    key: "upload-session",
                    label: "Upload sessions CSV",
                    callback: () => {
                      uploadDialogRef.current.openDialog();
                    },
                    startIcon: <RiGroupLine fontSize="medium" />,
                  },
                ]} />
            )}
          </Box>}
          <Box sx={classes.topFilters} display="flex">
              {/* <Paper sx={classes.searchForm}> */}
              <FdTextField
                id="searchInput"
                sx={classes.searchInput}
                placeholder="Search"
                type="text"
                inputRef={searchRef}
                name="search"
                onChange={(e) => {
                  const keyword = e.target.value;
                  setSearchKey(keyword);
                  debouncedSearch(e.target.value);
                } }
                value={searchKey}
                autoFocus
                onKeyDown={handleSearchKeyDown}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BiSearch size="18" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={classes.clearIcon}
                      onClick={handleSearchClear}
                    >
                      {searchKey.length > 0 && <BiX size="20" />}
                    </InputAdornment>
                  ),
                }} />
              {/* </Paper> */}
              <FdButton
                variant="contained"
                color="primary"
                onClick={onSearchClick}
                sx={classes.searchButton}
                ButtonName="Search" />
            </Box>
          {eventSessions && state.sessionLocations && (
            <Box sx={classes.listContent}>
              <GenericList
                type={dataType.SESSIONS}
                items={eventSessions}
                onDeleteItem={
                  canManageSession ? handleDeleteSession : undefined
                }
                onEditItem={(item: IEventSession) => {
                  redirect(
                    `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.SESSIONS}/${item.id}/${routePaths.EDIT}`
                  );
                }}
                style={{ width: "100%" }}
                onSelectItem={(item: IEventSession) => {
                  redirect(
                    `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.SESSIONS}/${item.id}/${routePaths.RESERVATIONS}`
                  );
                }}
                isLoading={scrollLoading}
                bulkActions={canManageSession ? bulkActions : undefined}
                customActions={canManageSession ? customActions : undefined}
                showFullSession={showFullSession}
              />
            </Box>
          )}

          {(!eventSessions || !state.sessionLocations) && <Loading />}
        </Box>
      </Box>

      <NotificationMessage ref={notificationRef} />

      <CSVUploadFlow
        ref={uploadDialogRef}
        type={dataType.SESSIONS}
        eventId={state.selectedEvent?.id}
        onCSVUpload={async (status: any, result: any) => {
          if (status === jobStatus.FINISHED) {
            await fetchEventSessions();
            notificationRef.current?.show(result, notificationType.Success);
          }

          if (status === jobStatus.ERROR) {
            notificationRef.current?.show(result, notificationType.Error);
          }
        }}
      />
    </>
  );
};

export default EventSessions;
